<template>
	<div class="_create-boarding _modal bg-white">
		<div
			class="
				_modal__content
				md-down:px-4
				px-12
				py-6
				flex flex-col
				items-center
				justify-center
			"
		>
			<div>
				<img src="@/assets/images/illustrations/holiday.png" alt="" />
			</div>
			<div
				class="
					_modal__content__title
					text-neutral-700
					font-semibold
					text-2xl
					mt-5
					text-center
				"
			>
				Ngày nghỉ đã được tạo tự động bởi Luca
			</div>
			<div
				class="
					text-center text-neutral-400
					mt-2
					font-base
					tracking-wide
				"
			>
				Luca đã giúp trung tâm tạo ngày nghỉ nhân dịp lễ sắp tới để giáo
				viên không bị làm phiền bởi thông báo. Quản lý có thể chỉnh sửa
				hoặc xóa trong mục Ngày nghỉ trên website, hoặc liên hệ với Luca
				để được hỗ trợ.
			</div>
		</div>
		<div
			class="
				_modal__footer
				px-12
				py-6
				bg-neutral-50
				flex flex-nowrap
				items-center
			"
		>
			<button
				type="button"
				class="
					button-p
					text-center
					mr-3
					bg-none
					shadow-none
					text-neutral-500
					hover:text-neutral-700
				"
				@click="$emit('close')"
			>
				Đã hiểu
			</button>
			<button
				type="button"
				class="button-p text-center whitespace-nowrap"
				@click="$emit('submit')"
			>
				Chỉnh sửa ngày nghỉ
			</button>
		</div>
	</div>
</template>
<script setup>

</script>